export default {
  issueKitchenTitle: "إصدار إلى المطبخ",
  issueKitchenSubtitle: "توزيع المكونات للعمليات اليومية",
  loadingInventory: "جارٍ تحميل المخزون...",
  item: "الصنف",
  available: "المتوفر",
  issueQty: "كمية الإصدار",
  action: "الإجراء",
  remarks: "ملاحظات",
  remarksPlaceholder: "ملاحظات اختيارية لموظفي المطبخ",
  items: "أصناف",
  qty: "كمية",
  issueKitchenButton: "إصدار إلى المطبخ",
  issuingNow: "جارٍ الإصدار...",
  cancel: "إلغاء",
  issueAtLeastOne: "يرجى إصدار صنف واحد على الأقل",
  issueFailed: "فشل في إصدار الأصناف"
};